import React from 'react';
import { useTrans } from '../../../hooks/useTrans';

export default function CustomerServiceContact() {
    const translate = useTrans();

    return (
        <div className="text-sm text-[#003545]">
            <p>{translate('Indien je problemen ervaart met inloggen, kun je contact opnemen met onze afdeling Customer Service via:')}</p>
            <a href="mailto:cs@schotpoort.nl" className="inline-flex items-center gap-1 font-bold text-[#003545] no-underline mt-3">
                <svg className="w-4 h-4 fill-[#ffd500]" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
                cs@schotpoort.nl
            </a>
        </div>
    );
}
